import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from '@ngrx/store';
import { Delta } from 'quill/core';

import { JobToolSubscriptionActions } from 'src/app/job/job-state/job-tool-subscription.actions';
import { NewOpportunityActions } from 'src/app/new-opportunity/new-opportunity.actions';

import { JobToolActions } from '../../job-tool.actions';

import { DiscardOpportunityDialogActions } from '../discard-job-component/discard-job.actions';

import { JobSummaryActions } from './job-create-summary.actions';
import { JobCreateSummaryState, jobCreateSummaryInitialState } from './job-create-summary.state';

export const summaryKeys = [ 'adminSummary', 'crewSummary', 'customerSummary' ] as const;

export type SummaryType = typeof summaryKeys[number];

export const jobSummaryReducers = [
    on(
      JobToolActions.jobLoaded,
      JobToolActions.jobDataReset,
      JobToolSubscriptionActions.remoteJobUpdated,
      (state: JobCreateSummaryState, { job }): JobCreateSummaryState => {
        return {
          ...state,
          summaryEditors: {
            ...state.summaryEditors,
            crewSummary: job?.crewSummary?.contents ? JSON.parse(job.crewSummary.contents) : new Delta(),
            adminSummary: job?.adminSummary?.contents ? JSON.parse(job.adminSummary.contents) : new Delta(),
            customerSummary: job?.customerSummary?.contents ? JSON.parse(job.customerSummary.contents) : new Delta(),
          },
        };
      },
    ),
    on(
      JobSummaryActions.summaryTabClicked,
      NewOpportunityActions.defaultSummaryIndexLoaded,
      (state: JobCreateSummaryState, { summaryIndex }): JobCreateSummaryState => {
          return {
            ...state,
            summaryEditors: {
              ...state.summaryEditors,
              summaryIndex,
            },
          }
        },
    ),
    on(JobSummaryActions.summaryEditorContentChanged, (state: JobCreateSummaryState, { key, delta }): JobCreateSummaryState => {
      return {
        ...state,
        summaryEditors: {
          ...state.summaryEditors,
          [key]: delta,
        },
      }
    }),
    on(DiscardOpportunityDialogActions.discardUnsavedChangesButtonClicked, (): JobCreateSummaryState => jobCreateSummaryInitialState),
    on(routerNavigatedAction, (state: JobCreateSummaryState, { payload: { event: { urlAfterRedirects } } }): JobCreateSummaryState => {
      if (urlAfterRedirects.startsWith('/jobs/new')) {
        return jobCreateSummaryInitialState;
      }
      return state;
    }),
] as const;
